import { Either } from '@playq/irt';

export const unwrapEither = <LeftData, RightData>(promise: Promise<Either<LeftData, RightData>>) =>
  new Promise<RightData>((resolve, reject) => {
    promise.then((data) => data.bifold(resolve, reject)).catch(reject);
  });
